import { Component, Input, OnInit, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { WizardStore } from '../stores/wizard-store.service';

@Component({
  selector: 'steps-header',
  templateUrl: './steps-header.component.html',
  styleUrls: ['./steps-header.component.scss']
})
export class StepsHeaderComponent implements OnInit {
  @Input() currentStep: number = 0;
  @Output() currentStepChange: EventEmitter<number> = new EventEmitter();

  constructor(public wizardStore: WizardStore) { }

  ngOnInit(): void {
  }

  onStepClicked(step: number): void {
    let jobId = this.wizardStore.getSelectedJobId();
    if(!jobId) {
      return;
    }

    if(step > 2) {
      this.wizardStore.getCandidateProfileInfos(jobId);
      if(!this.wizardStore.getSelectedCandidateId()) {
        return;
      }
    }

    this.currentStep = step;
    this.currentStepChange.emit(step);
  }

}
